import { Component, ChangeDetectionStrategy, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { AnnualReportTemplate } from '@vi-iot/client/apis/annual-report/annual-report.model';
import { takeUntil } from 'rxjs/operators';

import {
  AuthStore,
  DevicesStore,
  InstallationDetailsStore,
  RemoteServiceDiagnosisLoadingStatus,
  RemoteServiceStore,
} from '@store';

@Component({
  selector: 'app-remote-service-report',
  templateUrl: './remote-service-report.component.html',
  styleUrls: ['./remote-service-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemoteServiceReportComponent implements OnInit, OnDestroy {
  RemoteServiceDiagnosisLoadingStatus = RemoteServiceDiagnosisLoadingStatus;
  diagnosisCalculationDataStatus: RemoteServiceDiagnosisLoadingStatus;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  private deviceSerial: string;
  private gatewaySerial: string;
  readonly remoteServiceReportTemplate = AnnualReportTemplate.RemoteServiceViessmann;
  readonly yearlyReportTemplate = AnnualReportTemplate.ViGuideYearlyReport;

  constructor(
    public remoteServiceStore: RemoteServiceStore,
    public installationDetailsStore: InstallationDetailsStore,
    public authStore: AuthStore,
    public deviceStore: DevicesStore,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((queryParam) => {
      this.deviceSerial = queryParam.get('deviceSerial');
      this.gatewaySerial = queryParam.get('gatewaySerial');
    });

    this.remoteServiceStore.diagnosisCalculationDataStatus$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((dataStatus) => {
        this.diagnosisCalculationDataStatus = dataStatus;
      });
  }

  onDownloadServiceReportAnomalySummaryClicked(): void {
    this.getAnnualReport(
      AnnualReportTemplate.RemoteServiceViessmann,
      this.gatewaySerial,
      this.deviceSerial
    );
  }

  onDownloadYearlyReportAnomalySummaryClicked(): void {
    this.getAnnualReport(
      AnnualReportTemplate.ViGuideYearlyReport,
      this.gatewaySerial,
      this.deviceSerial
    );
  }

  private getAnnualReport(
    reportTemplate: AnnualReportTemplate,
    gatewaySerial: string,
    deviceSerial: string
  ): void {
    this.remoteServiceStore.getReport(reportTemplate, gatewaySerial, deviceSerial);

    this.remoteServiceStore.annualReportState$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((data) => {
        if (data.fileUri && data.loaded) {
          this.downloadFile(data.fileUri);
        }
      });
  }

  private downloadFile(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.download = url.substring(url.lastIndexOf('/') + 1);
    link.click();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
